// Same cap as the backend's MAX_TRAY_BULK_COUNT (trayValidation.ts) — keep them in step.
export const MAX_TRAY_BULK_COUNT = 500;

const WHOLE_NUMBER = /^\d+$/;

/** Why the "number of trays" input can't be submitted, or null when it can. */
export const trayCountError = (raw) => {
  const value = String(raw ?? "").trim();
  if (!value) return "Enter how many trays to generate";
  if (!WHOLE_NUMBER.test(value) || Number(value) < 1) return "Enter a whole number of at least 1";
  if (Number(value) > MAX_TRAY_BULK_COUNT) {
    return `You can generate up to ${MAX_TRAY_BULK_COUNT} trays at a time`;
  }
  return null;
};

/** Success toast text naming the barcodes that were created. */
export const generatedTraysMessage = (trays) => {
  if (!trays?.length) return "Trays generated";
  if (trays.length === 1) return `1 tray generated (barcode ${trays[0].barcode})`;
  const barcodes = trays.map((tray) => tray.barcode);
  return `${trays.length} trays generated (barcodes ${Math.min(...barcodes)} – ${Math.max(...barcodes)})`;
};
